module.exports = __webpack_public_path__ + "img/under-maintenance.c589ae72.svg";